import React from 'react'
import ONasFirst from '../components/ONasFirst/ONasFirst'
import SectionForm from '../components/SectionForm/SectionForm'
import WelcomeONas from '../components/WelcomeONas/WelcomeONas'

const ONas = () => {
	return (
		<>
			<WelcomeONas />
			<ONasFirst />
			<SectionForm />
		</>
	)
}

export default ONas
